import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const ContentWrapper = styled.div`
    grid-area: list;
    display: flex;
    flex-direction: column;
    padding-top: 24px;
    row-gap: 16px;
`;

export const Text = styled.div`
    color: ${COLORS.TextHint};
    ${FONTS.S};
    justify-content: flex-end;

    @media (max-width: ${wideBreakpoints.tablet}) {
        justify-content: flex-start;
    }
`;

export const Reviews = styled.div`
    width: 100%;
    row-gap: 16px;
    margin-top: 12px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-top: 0;
    }
`;

export const ShowMoreBtn = styled(Button)`
    width: fit-content;
    padding: 12px 24px;

    @media (max-width: ${wideBreakpoints.tablet}) {
        margin-bottom: 24px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding-top: 12px;
        padding-bottom: 12px;
        width: 100%;
    }
`;
